"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchResultsHeader = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Search results header component. This component is used to display the search query.
 */ const SearchResultsHeader = (param)=>{
    let { query, className, loaded } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _useTranslations.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.SEARCH_RESULTS_HEADER),
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                fontWeight: "bold",
                variant: "h5",
                component: "h5",
                align: "center",
                color: "textPrimary",
                children: translations.showingResultsFor
            }),
            loaded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Query, {
                align: "center",
                color: "textPrimary",
                children: "”".concat(query !== null && query !== void 0 ? query : '', "”")
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.QuerySkeleton, {})
        ]
    });
};
exports.SearchResultsHeader = SearchResultsHeader;
